module.exports = __webpack_public_path__ + "img/google.695a3160.svg";